import PropTypes from "prop-types";
import React, { useRef, useState, useEffect } from "react";
import axios from "axios";

const EncryptedNote = ({
  initial_decrypted_data,
  initial_pin,
  encrypted_note_path,
  edit_encrypted_note_path,
}) => {
  const inputRefs = useRef([]);
  const [data, setData] = useState(initial_decrypted_data);
  const [isError, setIsError] = useState(false);
  const [pin, setPin] = useState(
    initial_pin
      ? [initial_pin[0], initial_pin[1], initial_pin[2], initial_pin[3]]
      : ["", "", "", ""]
  );
  const [loading, setLoading] = useState(false);

  const handleError = () => {
    setPin(["", "", "", ""]);
    inputRefs.current.forEach((input) => {
      if (input) input.value = "";
    });
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    setIsError(true);
  };

  const sendPin = (pinParam) => {
    setLoading(true);
    axios
      .get(`${encrypted_note_path}.json?pin=${pinParam}`, {
        headers: ReactOnRails.authenticityHeaders({}),
      })
      .then((response) => {
        const { decrypted_data } = response.data;
        setData(decrypted_data);
        window.history.replaceState(
          null,
          null,
          `${window.location.pathname}?pin=${pinParam}`
        );
        setIsError(false);
      })
      .catch(() => {
        handleError();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleInput = (e, index) => {
    const value = e.target.value;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    if (value.length === 1) {
      if (index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      } else {
        sendPin(newPin.join(""));
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value) {
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  return (
    <>
      <div className="px-2 flex flex-col items-center justify-center space-y-4">
        {data ? (
          <div className="relative bg-white dark:bg-gray-800 max-w-xl p-6 rounded-lg w-full card-shadow">
            <h5 className="flex items-center mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              Encrypted Note
              <a
                href={`${edit_encrypted_note_path}?pin=${pin.join("")}`}
                className="ml-2"
              >
                <svg
                  className="w-6 h-6 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                  />
                </svg>
              </a>
            </h5>
            <div className="dark:text-gray-400 font-semibold text-gray-700 text-sm whitespace-pre-wrap">
              {data}
            </div>
          </div>
        ) : (
          <div className="relative max-w-xl p-6 pt-0 w-full">
            <h2 className="text-lg font-semibold text-center dark:text-white mb-4">
              Enter PIN
            </h2>
            <div className="flex gap-x-3 justify-center" data-hs-pin-input="">
              {Array.from({ length: 4 }).map((_, index) => (
                <input
                  key={index}
                  type="password"
                  inputMode="numeric"
                  className={`bg-white dark:bg-gray-800 block w-[38px] text-center ${
                    isError
                      ? "border-red-400"
                      : "border-gray-200 dark:border-neutral-700"
                  } rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600`}
                  placeholder="⚬"
                  maxLength="1"
                  disabled={loading}
                  ref={(el) => (inputRefs.current[index] = el)}
                  onInput={(e) => handleInput(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

EncryptedNote.propTypes = {
  initial_decrypted_data: PropTypes.string,
  initial_pin: PropTypes.string,
  encrypted_note_path: PropTypes.string,
  edit_encrypted_note_path: PropTypes.string,
};

export default EncryptedNote;
